export default "__VITE_ASSET__cf7709e2__"